'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _once2 = require('ramda/src/once');

var _once3 = _interopRequireDefault(_once2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCurrentYear = (0, _once3.default)(function () {
  return new Date().getFullYear();
});

exports.default = getCurrentYear;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/utils/getCurrentYear.js
// module id = 505
// module chunks = 4